import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Menu } from 'antd';
import {
  SettingOutlined
} from '@ant-design/icons';

export const NavSettings = () => {

  const history = useHistory()

  return (
    <Menu mode="horizontal" className="app-header-settings-menu">
      <Menu.Item key="settings" onClick={() => history.push('/settings/defaults')} className="app-header-top-nav-menu-item">
        <Button className="nav-icon mr-0" type="default" shape="circle" icon={<SettingOutlined />} />
      </Menu.Item>
    </Menu>
  );
}

export default NavSettings; 
